import { ReactNode } from "react";

import { Header } from "components/elements";
import { Subsection } from "components/layout";
import { NO_VALUE_PLACEHOLDER } from "src/constants";

import styles from "./SubsectionWithFallback.scss";

export type SubsectionWithFallbackProps<T> = {
  header: string;
  value: T;

  children: (value: NonNullable<T>) => ReactNode;
};

export function SubsectionWithFallback<T>({
  header,
  value,
  children,
}: SubsectionWithFallbackProps<T>) {
  if (!value || (Array.isArray(value) && value.length === 0)) {
    return <Subsection header={header}>{NO_VALUE_PLACEHOLDER}</Subsection>;
  }

  return (
    <div className={styles.container}>
      <Header type="h6" color="tertiary" uppercase>
        {header}
      </Header>
      {children(value)}
    </div>
  );
}
